<template>
    <div class="title font-weight-bold"
         :class="{ 'underline': underline, 'font24': font24, 'font22': font22, 'font20':font20 }">
        <!-- :style="{ 'font-size': fontSize }" -->
        <span>{{ titleText }}</span>
    </div>
</template>
<script>
export default {
    name: 'Theme',
    props: {
        underline: {
            type: Boolean,
            default: true,
        },
        titleText: {
            type: String,
            default: '',
            require: true,
        },
        // fontSize: {
        //     type: String,
        //     default: '1.375rem',
        // },
        font24: {
            type: Boolean,
            default: false,
        },
        font22: {
            type: Boolean,
            default: false,
        },
        font20: {
            type: Boolean,
            default: false,
        }
    },
};
</script>
<style lang="scss" scoped>
.title {
    // margin-bottom: 0.5rem;
    @include media-breakpoint-up(md) {
        margin-bottom: 1.25rem;
    }

    &.underline {
        border-bottom: 1px solid $gray-300;
        span {
            padding-bottom: 0.5rem;
            border-bottom: 2px solid $primary;
        }
    }
    &.font24 {
        font-size: 1.375rem;
        line-height: 2;
        @include media-breakpoint-up(md) {
            font-size: 1.5rem;
            line-height: 1.9;
        }
    }
    &.font22 {
        font-size: 1.375rem;
        line-height: 2;
    }
    &.font20 {
        font-size: 1.25rem;
        line-height: 2;
    }
}
</style>
